// const buyContractAddress = "0xa670c1b6eb08502Ab1bf58B63338964D06a515fa" /// binance market testnet
const buyContractAddress = "0x2C8dbE51Abbb1a66E75606aCe6C4053594C1BD1B" /// binance market mainnet

export default buyContractAddress;